<template>
    <div>
        <v-layout v-resize="onResize" row wrap pa-4 align-start justify-center class="white-bg">
            <v-flex xs12>
                <h1>Über den Tennis- und Eislaufclub Waldau (Stuttgart)</h1>
            </v-flex>
            <v-layout row wrap align-center justify-start :class="isMobile ? '' : 'ma-5' ">
                <v-flex class=" ma-2">
                    <v-layout align-start justify-center column fill-height>
                        <v-flex class="elevation-5 ma-2 black">
                            <youtube video-id="dphn850B_I4" width="300px" height="200px"/>
                        </v-flex>
                        <v-flex class="elevation-5 ma-2 black">
                            <youtube video-id="uqFn-soVsAc" width="300px" height="200px"/>
                        </v-flex>

                    </v-layout>
                </v-flex>

                <v-flex class="pa-3 pl-4 white-bg round-3">
                    <div style="max-width:800px">
                        <p>Der Tennis- und Eislaufclub Waldau zeichnet sich besonders durch dessen familiäre Atmosphäre
                            aus.</p>
                        <p>Unsere Trainer und Übungsleiter kümmern sich hingebungsvoll im Vereinstraining sowie in den
                            Privatstunden
                            um
                            unsere Sportler.</p>
                        <p> Mit unserem breiten Angebot ermöglichen wir klein und groß diesem faszinierenden athletisch
                            anspruchsvollen
                            gleich als künstlerisch wunderschönem Sport nachzugehen.</p>
                        <p>Zusätzlich zu unserem Eisangebot bieten wir Athletik sowie im Sommer Inlineskating an.</p>
                        <p>In einer speziellen Erwachsenengruppe kommen auch unsere größten nicht zu kurz.</p>
                        <p>Dabei kümmern wir uns um Sportler im Hobbybereich sowie im Leistungssport.</p>
                        <p>Außerdem unterstützen wir unsere Sportler, egal welcher Stufe, bei dem Wunsch an
                            Meisterschaften
                            teilzunehmen.</p>
                        <p>Wir zaubern besondere Shows bei speziellen Events, wie Stuttgart aufs Eis, auf die Eisfläche
                            und
                            organisieren
                            den bekannten Eisemannpokal.</p>
                        <v-layout row wrap justify-center align-center>

                            <v-flex class=" elevation-5 round-3 v-card--hover" :class="isMobile ? 'ma-2' : 'ma-4' ">
                                <a href="https://sw.tec-stuttgart.de/images/verein/Mitgliedsantrag.pdf" target="_blank">
                                    <v-img src="https://sw.tec-stuttgart.de//images/verein/mitgliedsantrag.png"
                                           alt="Mitgliedsantrag"></v-img>
                                </a>
                            </v-flex>
                            <v-flex class=" elevation-5 round-3 v-card--hover" :class="isMobile ? 'ma-2' : 'ma-4' "
                                    @click="info()">
                                <v-img src="http://sw.tec-stuttgart.de/images/verein/aufnahme.png"
                                       alt="Aufnahmeschreiben"></v-img>
                            </v-flex>
                            <aufnahmeschreiben :visible="asVisible" @update="asVisible = false"></aufnahmeschreiben>
                            <v-flex class=" elevation-5 round-3 v-card--hover" :class="isMobile ? 'ma-2' : 'ma-4' ">
                                <a href="https://sw.tec-stuttgart.de/images/verein/Vereinssatzung.pdf" target="_blank">
                                    <v-img src="https://sw.tec-stuttgart.de/images/verein/satzung.png"
                                           alt="Satzung"></v-img>
                                </a>
                            </v-flex>
                        </v-layout>

                    </div>


                </v-flex>
            </v-layout>
        </v-layout>
    </div>
</template>

<script>
    import Training from "./Training";
    import Aufnahmeschreiben from "../content/club/General/Aufnahmeschreiben";
    import {Resize, Scroll} from 'vuetify/es5/directives'

    export default {
        name: "ClubPage",
        components: {Aufnahmeschreiben, Training},
        data() {
            return {
                isMobile: true,
                asVisible: false,
            }
        },
        directives: {
            Resize, Scroll
        },
        methods: {
            onResize() {
                this.isMobile = window.innerWidth < 900
            },
            info() {
                // console.log(this.asVisible)
                this.asVisible = true
            }
        },
        mounted() {
            this.onResize()
            setTimeout(() => {
                this.$vuetify.goTo(0, {offset: 0, duration: 300, easing: 'easeOutCubic'})
            }, 100)
        }

    }
</script>
<style>

</style>

